import { BACKEND_URL } from "../config";

const baseUrl = BACKEND_URL;

const api = {
  auth: {
    signin: `${baseUrl}/auth/signin`,
    userVerify: `${baseUrl}/auth/userVerify`,
    createPassword: `${baseUrl}/auth/createPassword`,
    forgetPassword: `${baseUrl}/auth/forgetPassword`,
    resetPassword: `${baseUrl}/auth/resetPassword`,
  },
  setting: {
    readOrganization: `${baseUrl}/setting/readOrganization`,
    updateOrganization: `${baseUrl}/setting/updateOrganization`,
    createBoat: `${baseUrl}/setting/createBoat`,
    updateBoat: `${baseUrl}/setting/updateBoat`,
    deleteBoat: `${baseUrl}/setting/deleteBoat`,
    readBoatList: `${baseUrl}/setting/readBoatList`,
    readBoatListWithoutImage: `${baseUrl}/setting/readBoatListWithoutImage`,
    readBoatListAvailableWithoutImage: `${baseUrl}/setting/readBoatListAvailableWithoutImage`,
    readBoatTypeList: `${baseUrl}/setting/readBoatTypeList`,
    readPortList: `${baseUrl}/setting/readPortList`,
    readTourTypeList: `${baseUrl}/setting/readTourTypeList`,
    readTripDurationList: `${baseUrl}/setting/readTripDurationList`,
    readDestinationList: `${baseUrl}/setting/readDestinationList`,
    createDestination: `${baseUrl}/setting/createDestination`,
    createTour: `${baseUrl}/setting/createTour`,
    readTourList: `${baseUrl}/setting/readTourList`,
    readTourListWithoutImage: `${baseUrl}/setting/readTourListWithoutImage`,
    // readTour: `${baseUrl}/setting/readTour`,
    updateTour: `${baseUrl}/setting/updateTour`,
    deleteTour: `${baseUrl}/setting/deleteTour`,
    createTourAndDate: `${baseUrl}/setting/createTourAndDate`,
    readTourAndDateList: `${baseUrl}/setting/readTourAndDateList`,
    // readTourAndDate: `${baseUrl}/setting/readTourAndDate`,
    updateTourAndDate: `${baseUrl}/setting/updateTourAndDate`,
    deleteTourAndDate: `${baseUrl}/setting/deleteTourAndDate`,
    // readEventList: `${baseUrl}/setting/readEventList`,
    createBoatType: `${baseUrl}/setting/createBoatType`,
    createPort: `${baseUrl}/setting/createPort`,
    readGenderList: `${baseUrl}/setting/readGenderList`,
    createAgent: `${baseUrl}/setting/createAgent`,
    readAgentList: `${baseUrl}/setting/readAgentList`,
    readTeamList: `${baseUrl}/setting/readTeamList`,
    createTeam: `${baseUrl}/setting/createTeam`,
  },
  address: {
    readCountryList: `${baseUrl}/address/readCountryList`,
    readNationalityList: `${baseUrl}/address/readNationalityList`,
    // readProvinceList: `${baseUrl}/address/readProvinceList`,
    // readDistrictListByIdProvince: `${baseUrl}/address/readDistrictListByIdProvince`,
    // readSubdistrictListByIdDistrict: `${baseUrl}/address/readSubdistrictListByIdDistrict`,
    // readPostalCodeByIdSubdistrict: `${baseUrl}/address/readPostalCodeByIdSubdistrict`,
    readAllProvinceDistrictSubdistrict: `${baseUrl}/address/readAllProvinceDistrictSubdistrict`,
  },
  entry: {
    readGuestAgeSetting: `${baseUrl}/entry/readGuestAgeSetting`,
    createEntry: `${baseUrl}/entry/createEntry`,
    // readEntryList: `${baseUrl}/entry/readEntryList`,
    readEntry: `${baseUrl}/entry/readEntry`,
    updateEntry: `${baseUrl}/entry/updateEntry`,
    deleteEntry: `${baseUrl}/entry/deleteEntry`,
    readDataList: `${baseUrl}/entry/readDataList`,
  },
  report: {
    readReport: `${baseUrl}/report/readReport`,
    readHeaderData: `${baseUrl}/report/readHeaderData`,
  },
  utils: {
    seat: `${baseUrl}/utils/seat`,
    // numOfGroup: `${baseUrl}/utils/numOfGroup`,
    activeDateList: `${baseUrl}/utils/activeDateList`,
    tourListByActiveDate: `${baseUrl}/utils/tourListByActiveDate`,
    boatListByActiveDateAndIdTourList: `${baseUrl}/utils/boatListByActiveDateAndIdTourList`,
    tourOption: `${baseUrl}/utils/tourOption`,
    tourOptionByIdTourType: `${baseUrl}/utils/tourOptionByIdTourType`,
    dateOptionByIdTourAndIdTourType: `${baseUrl}/utils/dateOptionByIdTourAndIdTourType`,
    boatOptionByIdTourAndDateAndIdTourType: `${baseUrl}/utils/boatOptionByIdTourAndDateAndIdTourType`,
    seatByIdTourAndDateAndIdBoatAndIdTourType: `${baseUrl}/utils/seatByIdTourAndDateAndIdBoatAndIdTourType`,
    boatCapacity: `${baseUrl}/utils/boatCapacity`,
    requestGroupId: `${baseUrl}/utils/requestGroupId`,
    tourDetail: `${baseUrl}/utils/tourDetail`,
    readTokenQrCode: `${baseUrl}/utils/readTokenQrCode`,
    readDataForQrCodeA5: `${baseUrl}/utils/readDataForQrCodeA5`,
    readImageTourByIdTourAndDate: `${baseUrl}/utils/readImageTourByIdTourAndDate`,
    readDateListByTour: `${baseUrl}/utils/readDateListByTour`,
    getImageUriByImageUrlInGcs: `${baseUrl}/utils/getImageUriByImageUrlInGcs`,
  },
};

export default api;
